import React, { useState, useEffect } from 'react';
import { API_DOMAIN } from './globals'; // Import the global domain name
import { useNavigate } from 'react-router-dom';
import { Link } from "react-router-dom";
import useVisibility from './useVisibility';
import { clippingParents } from '@popperjs/core';

function Aviator() {

    const visibility = useVisibility();
    const navigate = useNavigate();
    const [userName, setUserName] = useState('');
    const [loading, setLoading] = useState(true);  // Loading state
    const [error, setError] = useState(null);  // Error state

    const param1 = sessionStorage.getItem("UserType");
    const param2 = sessionStorage.getItem("UserName");

    // Create an object to pass parameters to the GET request
    const params = {
        ut: param1,
        un: param2,
    };

    const getClientDetails = (e) => {
        e.preventDefault()

        const queryString = new URLSearchParams(params).toString();
        const url = `${API_DOMAIN}/api/Client/getClientDetails.php?${queryString}`;
        fetch(url, {
            method: 'GET',
            credentials: 'include', // Equivalent to withCredentials:true
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(response => response.json())
            .then(data => {
                if (data.Status == "Error") {
                    console.log(data.Message);
                    //window.location = '/';
                } else {
                    console.log(data.data);
                    sessionStorage.setItem('Coins', data.data[0].Coins);
                    sessionStorage.setItem('Exposure', data.data[0].Exposure);
                    //window.location = '/Dashboard';
                    navigate('/dashboard');
                }
                setLoading(false); // Set loading to false
            })
            .catch(err => {
                setError(err); // Save any error to the state
                setLoading(false); // Set loading to false
            });
    }

    useEffect(() => {
        // Define your parameters

        const UserName = sessionStorage.getItem("UserName");
        setUserName(UserName || '');


            return () => {
                // Define an asynchronous function
                const makeApiCall = async () => {
                    try {
                        const queryString = new URLSearchParams(params).toString();
                        const url = `${API_DOMAIN}/api/Client/getClientDetails.php?${queryString}`;

                        const response = await fetch(url, {
                            method: 'GET',
                            credentials: 'include', // Equivalent to withCredentials:true
                            headers: {
                                'Content-Type': 'application/json',
                            },
                        })
                            .then(response => response.json())
                            .then(data => {
                                if (data.Status == "Error") {
                                    console.log(data.Message);
                                    //window.location = '/';
                                } else {
                                    
                                    sessionStorage.setItem('Coins', data.data[0].Coins);
                                    sessionStorage.setItem('Exposure', data.data[0].Exposure);
                                    //window.location = '/Dashboard';
                                    //navigate('/dashboard');

                                    console.log("Coins="+data.data[0].Coins);
                                }
                                setLoading(false); // Set loading to false
                            })
                            .catch(err => {
                                setError(err); // Save any error to the state
                                setLoading(false); // Set loading to false
                            });


                    } catch (error) {
                        console.error('Error during API call on unmount:', error);
                    }
                };

                // Call the asynchronous function
                makeApiCall();
            };


    }, []);

    useEffect(() => {
        console.log("visibility : "+ visibility);
        if (visibility === "visible") {
            window.location.reload();
        }
    }, [visibility]);

    return (
        <div>

            {/* <div className="match-box">
                <div className="mod-header mod-header2">
                    <div className="select-tv-ico">

                        <span className="btn btn-warning" style={{ height: '40px', width: '100%' }} onClick={getClientDetails}>
                            Back
                        </span>

                    </div>
                </div>
                <div className="collapse"></div>
            </div> */}

            <div className="match-box">
                <iframe src={`https://aviator.urbet365.buzz/game/index.html?Other&${userName}&React-Ludo-C2&v=0.0.0.0.2`} style={{ margin: '0px', padding: '0px', width: '100%', border: '0px', height: '780px' }}></iframe>
            </div>

        </div>

    )
}

export default Aviator;